<template lang="pug">
</template>

<script>
import { mapGetters } from 'vuex';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'collections',
  computed: {
    ...mapGetters({
      collections: getters.GET_COLLECTIONS,
    }),
  },
  created() {
    this.pagination.page = this.page;
    this.getPage(this.pagination.page);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 10,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      this.$router.push({ name: 'events', query: { page } });
      this.$store.dispatch(actions.DO_GET_CHANNELS, {
        page: this.pagination.page,
        per: this.pagination.per,
      })
        .then(() => {
          this.pagination.total = response.record_count;
          setTimeout(() => {
            this.settings.loading = false;
          }, 250);
        });
    },
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Collections.vue